import React from 'react'

import Svg, {
  ClipPath,
  Defs,
  G,
  Path,
  RadialGradient,
  Rect,
  Stop,
} from 'react-native-svg'

const CoinRupee = ({ color = '#F2F7FF', ...props }: { color?: string }) => {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={48}
      height={48}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <G clipPath="url(#a)">
        <Rect width={24} height={24} fill={color} rx={4} />
        <Path
          fill="url(#b)"
          d="M21.083 15.931a.3.3 0 0 1-.217-.089c-.812-.824-2.517-.836-2.533-.836a.304.304 0 0 1-.216-.09.31.31 0 0 1 .216-.528c.08 0 1.971 0 2.967 1.016a.308.308 0 0 1 .067.338.308.308 0 0 1-.284.19Z"
        />
        <Path
          fill="url(#c)"
          d="M10.695 15.931a.3.3 0 0 1-.217-.089.31.31 0 0 1 0-.438c.996-1.003 2.887-1.016 2.967-1.016.08 0 .158.033.216.09a.31.31 0 0 1-.216.528c-.016 0-1.72 0-2.533.836a.305.305 0 0 1-.217.09Z"
        />
        <Path
          fill="url(#d)"
          d="M18.028 15.623H16.5l-.611-4.938a5.6 5.6 0 0 1 3.667 0c-.611 2.16-.917 3.086-1.528 4.938Z"
        />
        <Path
          fill="url(#e)"
          d="M13.75 15.623h1.528l.61-4.938a5.6 5.6 0 0 0-3.666 0c.611 2.16.917 3.086 1.528 4.938Z"
        />
        <Path
          fill="url(#f)"
          d="M17.111 14.08h-2.444l-.611-4.938a5.6 5.6 0 0 1 3.666 0l-.61 4.938Z"
        />
        <Path
          fill="url(#g)"
          d="M22 22.258c0 3.395-2.75 3.24-6.111 3.24-3.361 0-6.111.155-6.111-3.24s2.75-8.178 6.11-8.178c3.362 0 6.112 4.783 6.112 8.178Z"
        />
        <Path
          fill="url(#h)"
          d="M18.333 14.018h-4.888a.614.614 0 0 0-.612.617c0 .341.274.618.611.618h4.89a.614.614 0 0 0 .61-.618.614.614 0 0 0-.61-.617Z"
        />
        <Path
          fill="url(#i)"
          d="m5.26 22.185 2.96 2.416 5.074 4.142 2.22-2.721-5.073-4.142-2.96-2.416-2.221 2.721Z"
        />
        <Path
          fill="url(#j)"
          d="m16.22 25.3.775.634a.286.286 0 0 1 .1.166l-1.58-.079-5.074-4.141-2.96-2.416-.394-1.533c.063 0 .128.02.183.065l4.72 3.853.988.806 2.114 1.726 1.127.92Z"
        />
        <Path
          fill="url(#k)"
          d="m8.22 24.601 5.074 4.141.394 1.533a.287.287 0 0 1-.183-.065l-9.726-7.938a.287.287 0 0 1-.1-.166l1.58.08L8.22 24.6Z"
        />
        <Path
          fill="url(#l)"
          d="m7.087 17.931.394 1.533-2.221 2.721-1.58-.079a.244.244 0 0 1 .047-.2L6.9 18.017a.244.244 0 0 1 .187-.087Z"
        />
        <Path
          fill="#C28E4C"
          d="M8.523 18.93v.085a.269.269 0 0 0-.198-.084h.198Z"
        />
        <Path
          fill="url(#m)"
          d="M9.345 9.426c-.834 0-1.112 1.111-1.112 1.111s-.277-1.11-1.11-1.11c.833 0 1.11-1.112 1.11-1.112s.278 1.111 1.112 1.111Z"
        />
        <Path
          fill="url(#n)"
          d="M11.567 12.76c-.833 0-1.111-1.112-1.111-1.112s-.278 1.111-1.111 1.111c.833 0 1.11 1.112 1.11 1.112s.279-1.112 1.112-1.112Z"
        />
        <Path
          fill="url(#o)"
          d="M6.011 11.649c-.833 0-1.11-1.111-1.11-1.111s-.279 1.11-1.112 1.11c.833 0 1.111 1.112 1.111 1.112s.278-1.111 1.111-1.111Z"
        />
        <Path
          fill="url(#p)"
          d="m9.042 16.14 1.556 3.488 2.668 5.982 3.208-1.43-2.668-5.982-1.556-3.49-3.208 1.431Z"
        />
        <Path
          fill="#F4D6AF"
          d="m16.474 24.18 1.376.781a.252.252 0 0 1-.126.155l-.006.003-4.583 2.044a.244.244 0 0 1-.206-.007l.338-1.546 3.207-1.43Z"
        />
        <Path
          fill="url(#q)"
          d="m17.428 23.853.408.914a.286.286 0 0 1 .015.194l-1.377-.782-2.668-5.981-1.556-3.49.338-1.546a.287.287 0 0 1 .134.14l2.482 5.566.52 1.164 1.111 2.492.593 1.329Z"
        />
        <Path
          fill="url(#r)"
          d="m10.599 19.628 2.668 5.982-.338 1.546a.286.286 0 0 1-.134-.14L7.68 15.55a.286.286 0 0 1-.015-.194l1.376.782 1.557 3.49Z"
        />
        <Path
          fill="url(#s)"
          d="m12.588 13.162-.338 1.546-3.208 1.431-1.376-.781A.243.243 0 0 1 7.8 15.2l4.583-2.044a.243.243 0 0 1 .206.006Z"
        />
      </G>
      <Defs>
        <RadialGradient
          id="b"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(-1.8685 1.24001 -3.24693 -4.89257 20.573 14.841)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <RadialGradient
          id="c"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(-1.8685 1.24001 -3.24693 -4.89257 12.933 14.841)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <RadialGradient
          id="d"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(-1.24013 2.64043 -2.2428 -1.05337 19.126 11.377)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="e"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(-.6141 2.54441 -2.1577 -.52077 14.834 11.473)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="f"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(-1.24013 2.64043 -2.2428 -1.05337 17.293 9.835)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="g"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="rotate(125.748 4.63 12.826) scale(9.87851 6.11065)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="h"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="rotate(163.714 7.7 8.44) scale(3.53742 5.41164)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <RadialGradient
          id="i"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="rotate(49.153 -18.873 16.335) scale(12.239 12.5831)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFEACE" />
          <Stop offset={1} stopColor="#E9C290" />
        </RadialGradient>
        <RadialGradient
          id="j"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(10.82956 11.42048 -3.47611 3.29625 7.174 16.345)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#F8C17C" />
          <Stop offset={1} stopColor="#C18E4B" />
        </RadialGradient>
        <RadialGradient
          id="k"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(10.82956 11.42048 -3.47611 3.29625 4.319 19.844)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <RadialGradient
          id="l"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="rotate(118.916 -.572 10.25) scale(8.69582 3.14955)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <RadialGradient
          id="m"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(-2.01254 -1.8764 1.74068 -1.86698 9.2 10.368)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="n"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(-2.01254 1.8764 -1.74068 -1.86698 11.422 11.818)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#E0ECFF" />
          <Stop offset={1} stopColor="#92BBFF" />
        </RadialGradient>
        <RadialGradient
          id="o"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(-2.01254 1.8764 -1.74068 -1.86698 5.867 10.707)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#E0ECFF" />
          <Stop offset={1} stopColor="#92BBFF" />
        </RadialGradient>
        <RadialGradient
          id="p"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="rotate(75.894 -3.937 13.963) scale(12.239 12.5831)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFEACE" />
          <Stop offset={1} stopColor="#E9C290" />
        </RadialGradient>
        <RadialGradient
          id="q"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(4.53276 15.07185 -4.5875 1.37966 13.38 11.785)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#F8C17C" />
          <Stop offset={1} stopColor="#C18E4B" />
        </RadialGradient>
        <RadialGradient
          id="r"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(4.53276 15.07185 -4.5875 1.37966 9.255 13.625)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <RadialGradient
          id="s"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(-7.17984 4.90584 -1.77685 -2.60047 14.515 11.644)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <ClipPath id="a">
          <Rect width={24} height={24} fill="#fff" rx={4} />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default CoinRupee
